var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left"},[_vm._v(" Unfortunately, due to local regulations this service is not available in your region. "),_c('b-btn',{staticClass:"mt-4",attrs:{"variant":"secondary","pill":"","block":""},on:{"click":function($event){return _vm.$store.dispatch('user/logout')}}},[_vm._v(" Logout ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }